import * as StoreInformationActions from './StorelocationInformation.actions';
import { StorelocationInformation } from './StorelocationInformation.model';

export interface State {
  storelocationInformation: StorelocationInformation;
}

const initialState: State = {
  storelocationInformation: {
    StoreLocationId: 0,
    StoreLocationName:''
  }

};

export function storelocationReducer(state = initialState, action: StoreInformationActions.AddStorelocationInformation) {
  switch (action.type) {
    case (StoreInformationActions.ADD_STORE_INFORMATION):
      const updatedStorelocation: StorelocationInformation = action.payload;
      let updatedStoreLocations = state.storelocationInformation;
      updatedStoreLocations = updatedStorelocation;
      return {
        ...state,
        storelocationInformation: updatedStoreLocations
      };

    default:
      return state;
  }
}
